import GlobalSettingsPage from './global-settings.page.vue'

let routes = [
  {
    path: '/global-settings',
    name: 'global-settings',
    component: GlobalSettingsPage
  }
]

export default routes
